// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/template-home';
import aboutUs from './routes/about';
import templateExpertise from './routes/template-expertise';
import singleTours from './routes/single-tours';
import templateDiscover from './routes/template-discover';
import templateNewsEvents from './routes/template-news-events';
import templateBespokeServices from './routes/template-bespoke-services';
import single from './routes/single';
import singlePeriodChapters from './routes/single-period-chapters';
import singleGemstoneChapters from './routes/single-gemstone-chapters';
import pageMyAccountData from './routes/page-my-account-data';
import page from './routes/page';
import singleCollect from './routes/single-collect';
import singleNewsEvents from './routes/single-news-events';
import singleBespokeServices from './routes/single-bespoke-services';
import templateExperiences from './routes/template-experiences';
import templateArticles from './routes/template-articles';
import templateContact from './routes/template-contact';
import templateCollect from './routes/template-collect';
import templateSingleLocation from './routes/template-single-location';


/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  templateHome,
  aboutUs,
  templateExpertise,
  singleTours,
  templateDiscover,
  templateNewsEvents,
  singlePeriodChapters,
  pageMyAccountData,
  single,
  page,
  singleGemstoneChapters,
  singleCollect,
  singleNewsEvents,
  templateExperiences,
  templateBespokeServices,
  singleBespokeServices,
  templateContact,
  templateArticles,
  templateCollect,
  templateSingleLocation,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js